import React from 'react'

const IncidentReporting = () => {
  return (
    <div className='mx-auto p-4'>
      IncidentReporting
    </div>
  )
}

export default IncidentReporting
